/* Confo.Inno · comportements animés des blocs (repris de la maquette approuvée).
   Chaque comportement s'accroche à un bloc par sa classe ou son attribut data- :
   - matrices d'employés (Formule) : points par vagues, puis points corail ;
   - grille Loi 27 : filets qui se tracent, valeurs, frise ;
   - étapes : colonne de vertèbres, section épinglée au défilement ;
   - portraits : léger zoom qui se pose ;
   - carte de pression BackRelief : tracé, puis corail → vert ;
   - motif couleur : dérive lente ; pied de page : logotype et dégradé maillé.
   Sans mouvement (réglage, préférence système, éditeur de thème) : état final, rien de caché. */
(function () {
  'use strict';
  var CI = window.ConfoInno;
  if (!CI) return;
  var svgEl = CI.svgEl, rgb = CI.rgb, C = CI.C;
  var une = function (el, cle) { if (el.dataset[cle]) return false; el.dataset[cle] = '1'; return true; };
  var bureau = window.matchMedia('(min-width: 981px)');

  /* ---------- Matrices d'employés ---------- */
  function matrices(racine, anime) {
    racine.querySelectorAll('.ci-profil__points').forEach(function (svg) {
      if (!une(svg, 'ciFait')) return;
      var cols = +svg.dataset.cols || 8, rows = +svg.dataset.rows || 6, part = parseFloat(svg.dataset.part) || 0;
      var graine = (parseInt(svg.dataset.seed, 16) % 2147483000) + 7;
      var r = CI.rand(graine), gap = cols > 10 ? 22 : 34, rad = cols > 10 ? 4 : 7;
      svg.setAttribute('viewBox', '0 0 ' + cols * gap + ' ' + rows * gap);
      if (cols <= 10) svg.style.maxWidth = cols * gap + 'px';
      for (var y = 0; y < rows; y++) for (var x = 0; x < cols; x++) {
        var chaud = r() < part;
        svgEl(svg, 'circle', { cx: x * gap + gap / 2, cy: y * gap + gap / 2, r: rad, fill: chaud ? '#FF5A36' : 'rgba(0,60,117,.22)', 'class': chaud ? 'chaud' : '' });
      }
      if (!anime) return;
      var tous = Array.prototype.slice.call(svg.querySelectorAll('circle')), chauds = svg.querySelectorAll('.chaud');
      var pret = false;
      gsap.set(chauds, { attr: { fill: 'rgba(0,60,117,.22)' } });
      gsap.timeline({ scrollTrigger: { trigger: svg, start: 'top 80%', once: true }, onComplete: function () { pret = true; } })
        .from(tous, { scale: 0, transformOrigin: '50% 50%', duration: 0.45, ease: 'back.out(2)', stagger: { amount: 0.9, grid: [rows, cols], from: 'start', axis: 'x' } })
        .to(chauds, { attr: { fill: '#FF5A36' }, duration: 0.3, stagger: { amount: 0.6, from: 'random' } }, '+=.1');

      // Survol de la vignette (souris seulement) : une onde part du centre de la matrice, puis les
      // points grossissent près du curseur, comme des capteurs qui réagissent à une pression.
      var carte = svg.closest('.ci-profil');
      if (!carte || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var rayon = gap * 3.2, image = 0, px = 0, py = 0, dessus = false;
      var proximite = function () {
        image = 0;
        var b = svg.getBoundingClientRect(), k = (cols * gap) / b.width;
        var x = (px - b.left) * k, y = (py - b.top) * k;
        tous.forEach(function (c) {
          var d = Math.hypot(c.cx.baseVal.value - x, c.cy.baseVal.value - y);
          c.setAttribute('r', (rad * (1 + (dessus ? 0.9 * Math.max(0, 1 - d / rayon) : 0))).toFixed(2));
        });
      };
      carte.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !pret) return;
        gsap.timeline()
          .to(tous, { scale: 1.5, duration: 0.22, ease: 'power2.out', stagger: { amount: 0.45, grid: [rows, cols], from: 'center' }, overwrite: true })
          .to(tous, { scale: 1, duration: 0.3, ease: 'power2.inOut', stagger: { amount: 0.45, grid: [rows, cols], from: 'center' } }, 0.2);
      });
      carte.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || !pret) return;
        px = e.clientX; py = e.clientY; dessus = true;
        if (!image) image = requestAnimationFrame(proximite);
      });
      carte.addEventListener('pointerleave', function () {
        dessus = false;
        if (!image) image = requestAnimationFrame(proximite);
      });
    });
  }

  /* ---------- Grille Loi 27 ---------- */
  function grillesLoi(racine, anime) {
    racine.querySelectorAll('[data-ci-grille-loi]').forEach(function (g) {
      if (!une(g, 'ciFait')) return;
      var cellules = g.querySelectorAll('.ci-cellule'), rangs = Math.max(1, Math.ceil(cellules.length / 2));
      var trait = function (sens, style) { var t = document.createElement('span'); t.className = 'ci-grille-loi__trait ci-grille-loi__trait--' + sens; t.setAttribute('aria-hidden', 'true'); t.setAttribute('style', style); g.appendChild(t); return t; };
      var hs = [], vs = [];
      for (var i = 0; i <= rangs; i++) hs.push(trait('h', i === rangs ? 'bottom:0' : 'top:' + (i / rangs) * 100 + '%'));
      vs.push(trait('v', 'left:0'), trait('v', 'left:47.4%'), trait('v', 'right:0'));
      if (!anime) return;
      var visuel = g.closest('.ci-grille-loi') || g, piste = visuel.querySelector('.ci-grille-loi__piste span');
      var enfants = [];
      cellules.forEach(function (c) { Array.prototype.push.apply(enfants, c.children); });
      var tl = gsap.timeline({ scrollTrigger: { trigger: g, start: 'top 78%', once: true } })
        .from(hs, { scaleX: 0, duration: 0.7, ease: 'power2.inOut', stagger: 0.12 })
        .from(vs, { scaleY: 0, duration: 0.7, ease: 'power2.inOut', stagger: 0.12 }, 0.2)
        .from(enfants, { y: 16, autoAlpha: 0, duration: 0.5, ease: 'power2.out', stagger: 0.05 }, 0.7);
      if (piste) tl.from(piste, { scaleX: 0, duration: 1.1, ease: 'power2.inOut' }, 1.1);
    });
  }

  /* ---------- Étapes : colonne de vertèbres, section épinglée ---------- */
  function etapes(racine, anime) {
    racine.querySelectorAll('.ci-etapes').forEach(function (bloc) {
      if (!une(bloc, 'ciFait')) return;
      var colonne = bloc.querySelector('.ci-etapes__colonne'), items = Array.prototype.slice.call(bloc.querySelectorAll('.ci-etape'));
      var n = items.length, vs = [], disques = [];
      if (!n) return;
      items.forEach(function (e, i) {
        colonne.insertAdjacentHTML('beforeend', '<span class="ci-etapes__vertebre"><svg viewBox="0 0 48 34"><path d="' + CI.VERTEBRE + '"/></svg></span>');
        vs.push(colonne.lastElementChild);
        if (i < n - 1) { colonne.insertAdjacentHTML('beforeend', '<span class="ci-etapes__disque"><span></span></span>'); disques.push(colonne.lastElementChild.firstChild); }
      });
      var etat = function (actif, finale) {
        items.forEach(function (e, i) {
          e.classList.toggle('is-active', !finale && i === actif);
          e.classList.toggle('is-avenir', !finale && i > actif);
          vs[i].className = 'ci-etapes__vertebre ' + (finale || i < actif ? 'is-faite' : i === actif ? 'is-active' : 'is-avenir');
        });
      };
      var remplir = function (v) { disques.forEach(function (d, i) { d.style.transform = 'scaleX(' + Math.max(0, Math.min(1, v - i)) + ')'; }); };

      if (!anime) {
        // Éditeur de thème : état de la maquette (avant-dernière étape en cours). Sinon : tout complété.
        if (CI.designMode && n > 1) { etat(n - 2); remplir(n - 2); } else { etat(n - 1, true); remplir(n); }
        return;
      }
      var section = bloc.closest('.ci-section'), enveloppe = section && section.parentElement;
      // Épinglage en CSS (position: sticky) : l'enveloppe de la section est allongée de 150 vh et la
      // section reste collée en haut, sur toute la hauteur de l'écran. C'est le navigateur qui la
      // tient en place : aucun saut, et la molette fonctionne partout. ScrollTrigger ne sert qu'à
      // lire la progression. Si le contenu dépasse la hauteur de l'écran, on n'épingle pas.
      var epingle = false;
      if (bloc.dataset.epingler === 'true' && bureau.matches && enveloppe) {
        enveloppe.classList.add('ci-epingle');
        epingle = section.scrollHeight <= window.innerHeight + 1;
        if (!epingle) enveloppe.classList.remove('ci-epingle');
      }
      if (epingle) {
        etat(0);
        var dernier = 0, portee = n - 1 + 0.6;
        ScrollTrigger.create({
          trigger: enveloppe, start: 'top top', end: 'bottom bottom', scrub: true,
          onUpdate: function (st) {
            var v = st.progress * portee, a = Math.min(n - 1, Math.floor(v));
            remplir(v);
            if (a !== dernier) { dernier = a; etat(a); gsap.fromTo(vs[a].querySelector('svg'), { scale: 1.6 }, { scale: 1.34, duration: 0.3, ease: 'power2.out', clearProps: 'scale' }); }
          }
        });
        gsap.from(items, { y: 24, autoAlpha: 0, duration: 0.6, stagger: 0.08, ease: 'power2.out', scrollTrigger: { trigger: bloc, start: 'top 90%', once: true } });
      } else if (!bureau.matches) {
        // Mobile : colonne verticale, sans épinglage. L'étape active est celle qui a franchi la ligne
        // des 60 % de l'écran ; le disque entre deux vertèbres se remplit selon le défilement.
        var fils = items.map(function (e) { return e.querySelector('.ci-etape__fil span'); });
        var liste = bloc.querySelector('.ci-etapes__liste'), courant = -1;
        var majMobile = function () {
          var ligne = window.innerHeight * 0.6, hauts = items.map(function (e) { return e.getBoundingClientRect().top; });
          var fin = items[n - 1].getBoundingClientRect().bottom < ligne, actif = 0;
          hauts.forEach(function (h, i) { if (h <= ligne) actif = i; });
          fils.forEach(function (f, i) {
            if (!f || i >= n - 1) return;
            var p = (ligne - hauts[i]) / Math.max(1, hauts[i + 1] - hauts[i]);
            f.style.transform = 'scaleY(' + Math.max(0, Math.min(1, p)) + ')';
          });
          var cle = fin ? n : actif;
          if (cle === courant) return;
          courant = cle;
          if (fin) { etat(n - 1, true); return; }
          etat(actif);
          gsap.fromTo(items[actif].querySelector('.ci-etape__vertebre svg'), { scale: 1.5 }, { scale: 1.22, duration: 0.3, ease: 'power2.out', clearProps: 'scale' });
        };
        etat(0);
        fils.forEach(function (f) { if (f) f.style.transform = 'scaleY(0)'; });
        ScrollTrigger.create({ trigger: liste, start: 'top bottom', end: 'bottom top', onUpdate: majMobile, onRefresh: majMobile });
        gsap.from(items, { y: 24, autoAlpha: 0, duration: 0.6, stagger: 0.08, ease: 'power2.out', scrollTrigger: { trigger: bloc, start: 'top 85%', once: true } });
      } else {
        etat(n - 1, true); remplir(n);
        gsap.from(items, { y: 24, autoAlpha: 0, duration: 0.6, stagger: 0.08, ease: 'power2.out', scrollTrigger: { trigger: bloc, start: 'top 85%', once: true } });
      }
    });
  }

  /* ---------- Portraits : zoom qui se pose ---------- */
  function portraits(racine, anime) {
    if (!anime) return;
    racine.querySelectorAll('.ci-portrait__cadre').forEach(function (el) {
      if (!une(el, 'ciFait')) return;
      gsap.fromTo(el.children, { scale: 1.06 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom 40%', scrub: true } });
    });
  }

  /* ---------- Carte de pression BackRelief ---------- */
  function pressions(racine, anime) {
    racine.querySelectorAll('[data-ci-pression]').forEach(function (visuel) {
      if (!une(visuel, 'ciFait')) return;
      var carte = visuel.querySelector('.ci-pression__carte'), tous = [], chauds = [];
      var cx = 348, cy = 310, s = 1.05;
      for (var j = 8; j >= 0; j--) {
        tous.push(svgEl(carte, 'path', { d: CI.blobPath(cx, cy, (120 + j * 26) * s, 1.35, 0.7 + j * 0.3), fill: 'none', stroke: rgb(j < 3 ? C.bleu : C.vert, j < 3 ? 0.6 - j * 0.1 : 0.85 - (j - 3) * 0.1), 'stroke-width': 1.3, pathLength: 1 }));
      }
      for (var i = 4; i >= 0; i--) {
        [[-70, 1 + i * 0.4], [70, 2.3 + i * 0.35]].forEach(function (d) {
          var chaud = i < 2;
          var p = svgEl(carte, 'path', { d: CI.blobPath(cx + d[0] * s, cy, (18 + i * 16) * s, 1, d[1]), fill: 'none', stroke: chaud ? rgb(C.corail, 1 - i * 0.25) : rgb(C.bleu, 0.85 - (i - 2) * 0.15), 'stroke-width': 1.5, pathLength: 1 });
          tous.push(p); if (chaud) chauds.push(p);
        });
      }
      if (!anime) return;
      var section = visuel.closest('.ci-section') || visuel;
      gsap.fromTo(visuel, { scale: 0.92 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: section, start: 'top bottom', end: 'center center', scrub: true } });
      gsap.set(tous, { attr: { 'stroke-dasharray': 1, 'stroke-dashoffset': 1 } });
      var depart = parseFloat(visuel.dataset.appui) || 52, appui = { g: depart };
      var g = visuel.querySelector('[data-appui-g]'), d = visuel.querySelector('[data-appui-d]'), b = visuel.querySelector('[data-appui-b]');
      var maj = function () { var v = Math.round(appui.g); g.textContent = v; d.textContent = 100 - v; b.style.width = v + '%'; };
      gsap.timeline({ scrollTrigger: { trigger: visuel, start: 'top 75%', once: true } })
        .to(tous, { attr: { 'stroke-dashoffset': 0 }, duration: 1.1, ease: 'power2.inOut', stagger: 0.07 })
        .from(visuel.querySelectorAll('.ci-carte'), { y: 16, autoAlpha: 0, duration: 0.6, stagger: 0.15, ease: 'power2.out' }, '-=.6')
        .add(function () {
          gsap.timeline({ repeat: -1, yoyo: true, repeatDelay: 1.6, delay: 0.8 })
            .to(chauds, { attr: { stroke: rgb(C.vert, 0.9) }, duration: 1.6, ease: 'sine.inOut' })
            .to(appui, { g: 50, duration: 1.6, ease: 'sine.inOut', onUpdate: maj }, 0);
        });
    });
  }

  /* ---------- Motif couleur : dérive lente ; pied de page ---------- */
  function decors(racine, anime) {
    if (!anime) return;
    racine.querySelectorAll('svg[data-ci-motif="couleur"]').forEach(function (m) {
      if (!une(m, 'ciDerive')) return;
      gsap.to(m, { xPercent: -6, yPercent: 4, duration: 20, ease: 'sine.inOut', yoyo: true, repeat: -1 });
    });
    racine.querySelectorAll('[data-ci-logotype]').forEach(function (l) {
      if (!une(l, 'ciFait')) return;
      gsap.from(l.querySelectorAll('path'), { yPercent: 105, ease: 'none', stagger: 0.05, scrollTrigger: { trigger: l, start: 'top bottom', end: 'bottom bottom', scrub: 0.6 } });
    });
    racine.querySelectorAll('.ci-pied__maille').forEach(function (m) {
      if (!une(m, 'ciFait')) return;
      gsap.to(m, { backgroundPosition: '100% 100%, 0% 100%, 30% 100%, 0 0', duration: 10, ease: 'sine.inOut', yoyo: true, repeat: -1 });
    });
  }

  function init(racine) {
    var anime = CI.mouvement() && !CI.designMode;
    matrices(racine, anime);
    grillesLoi(racine, anime);
    etapes(racine, anime);
    portraits(racine, anime);
    pressions(racine, anime);
    decors(racine, anime);
  }

  var demarrer = function () { init(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
